import React, { Component } from 'react';
import '../../App.css';

class Click extends Component {

constructor() {
	super();
	this.state = {userCounter1: 0, userCounter2: 0, message: "Game Over", timers: 10};
	this.incrementUser = this.incrementUser.bind(this);
	this.press = this.press.bind(this);
}

componentDidMount() {
	document.getElementById("areana").click()
	this.press;
	this.timers();
}

componentWillUnmount() {
	if (this.state.userCounter1 > this.state.userCounter2){this.props.winner("Blue", "Pink", this.state.userCounter1, this.state.userCounter2);}
	else if (this.state.userCounter1 < this.state.userCounter2){this.props.winner("Pink", "Blue", this.state.userCounter2, this.state.userCounter1);}
	else if (this.state.userCounter1 === this.state.userCounter2){this.props.tie(this.state.userCounter1);}
}

press(event) {
	if (event.keyCode === 83) {
		this.setState(state => ({userCounter1: state.userCounter1 += 1}));
	}
	if (event.keyCode === 75) {
		this.setState(state => ({userCounter2: state.userCounter2 += 1}));
	}
	else {
		return;
	}
}

incrementUser(player) {

	if (player === 0) {
		this.setState(state => ({
		userCounter1: state.userCounter1 += 1,
	}));
	}

	else {
		this.setState(state => ({
		userCounter2: state.userCounter2 += 1,
	}));
	}
}

timers() {

	//let timer = this.state.timers;

	//let Timing = setInterval(()=>{this.setState(state => ({timers: state.timers -= 1}))}, 1000);

	setTimeout(()=>{document.getElementById("player1").style.transform='scale(0)';}, 500);
	setTimeout(()=>{document.getElementById("player2").style.transform='scale(0)';}, 500);
}

  render() {

  	const mobile = window.innerWidth;
    return (
      <div onKeyDown={this.press} id="areana">
	    <div className="buttonView">
	      <div className="player">
	        <button style={{webkitTapHighlightColor: 'transparent',}} id="player1" onClick={() => {if(mobile>600){this.incrementUser(0)}}} onTouchStart={() => {if(mobile<600){this.incrementUser(0)}}} className={'blueButton'}>+</button>
	      </div>
	      <div id="player2div" className="player">
	        <button style={{webkitTapHighlightColor: 'transparent',}} id="player2" onClick={() => {if(mobile>600){this.incrementUser(1)}}} onTouchStart={() => {if(mobile<600){this.incrementUser(1)}}} className={'pinkButton'}>+</button>
	       </div>
	       <div className="scoreView">
	       	<span className="userScore" id="score1">
	        	<h1 className="score">{this.state.userCounter1} </h1>
	        </span>
	        <span className="userScore" id="score2">
	        	<h1 className="score">{this.state.userCounter2} </h1>
	        </span>
	    </div>
       </div>
      </div>
    );
  }
}

export default Click;



// WEBPACK FOOTER //
// ./src/components/layouts/Click.js